import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
import { cva as a } from "class-variance-authority";
//#region src/components/primitives/label.tsx
var o = ["className"], s = a("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"), c = r.forwardRef((r, a) => {
	let { className: c } = r, l = t(r, o);
	return /* @__PURE__ */ i("label", n({
		ref: a,
		"data-slot": "label",
		className: e(s(), c)
	}, l));
});
c.displayName = "Label";
//#endregion
export { c as Label, s as labelVariants };

//# sourceMappingURL=label.js.map